require('sanatoriums/new_design/desktop/filter');
